module.exports = __webpack_public_path__ + "img/scene.4b06754b.png";